'use client'

import Link from 'next/link'

import Button from 'shared/ui/Button'
import { PATHS } from 'shared/utils/paths'

import styles from './SaleOrderSummaryNotFound.module.scss'

export const SaleOrderSummaryNotFound = () => {
  return (
    <div className={styles.emptyStateWrapper}>
      Nie udało się znaleźć zamówienia
      <Link href={PATHS.home} className={styles.backHome}>
        <Button variant='primary' size='large' fullWidth>
          Wróć do sklepu
        </Button>
      </Link>
    </div>
  )
}
